import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    reason:
      'To date, we are not in a position to comply with these constraints and therefore cannot validate your account creation.',
  },
  fr: {
    reason:
      'À ce jour, nous ne sommes pas en capacité de nous conformer à ces contraintes et ne pouvons donc pas valider votre création de compte.',
  },
} as const);
